<div class="row">
  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Name</label>
      <input type="text" #name class="form-control" name="Name" [(ngModel)]="model.Name" />
      <app-tooltip [form]="'system.provider'" [uid]="'Name'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Abbreviation</label>
      <input
        type="text"
        class="form-control"
        name="Abbreviation"
        [value]="model.Abbreviation || ''"
        (input)="updateAbbreviation($event.target.value)"
      />
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">NPI</label>
      <input
        type="text"
        #npi
        class="form-control"
        name="NPI"
        [(ngModel)]="model.Npi"
        [appInputMask]="util.constants.masks.npi"
      />
      <app-tooltip [form]="'system.provider'" [uid]="'NPI'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">NPI Type</label>
      <app-select
        #npiType
        name="NpiType"
        [items]="npiTypeOptions"
        [selected]="npiTypeSelected"
        placeholder="Select an NPI Type"
      ></app-select>
      <app-tooltip [form]="'system.provider'" [uid]="'NpiType'"></app-tooltip>
    </div>
  </div>

  <!-- App select creates a vacuum effect and pushes things to the right on the row below; this is to help alleviate that -->
  <div class="col-md-3" style="margin-bottom: -0.5rem">
    <div class="form-group">
      <label class="control-label">Provider Type</label>
      <app-select
        #providerType
        name="ProviderType"
        [items]="providerTypeOptions"
        [selected]="providerTypeSelected"
        placeholder="Select a Provider Type"
      ></app-select>
      <app-tooltip [form]="'system.provider'" [uid]="'ProviderType'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Tax ID</label>
      <input
        type="text"
        #taxId
        class="form-control"
        name="TaxId"
        [(ngModel)]="model.TaxIdNumber"
        (keypress)="numberOnly($event)"
        [appInputMask]="util.constants.masks.taxId"
      />
      <app-tooltip [form]="'system.provider'" [uid]="'TaxId'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Phone Number</label>
      <input
        type="text"
        #phoneNumber
        class="form-control"
        name="PhoneNumber"
        [(ngModel)]="model.PhoneNumber"
        [appInputMask]="util.constants.masks.usPhone"
      />
      <app-tooltip [form]="'system.provider'" [uid]="'PhoneNumber'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Local 911 Phone Number</label>
      <input
        type="text"
        #local911Phone
        class="form-control"
        name="Local911PhoneNumber"
        [(ngModel)]="model.Local911PhoneNumber"
        [appInputMask]="util.constants.masks.usPhone"
      />
      <app-tooltip [form]="'system.provider'" [uid]="'Local911Phone'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Email</label>
      <input
        type="text"
        #email
        class="form-control"
        name="Email"
        [(ngModel)]="model.EmailAddress"
      />
      <app-tooltip [form]="'system.provider'" [uid]="'Email'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Time Zone</label>
      <app-select
        #timezone
        [items]="timezoneOptions"
        [selected]="timezoneSelected"
        placeholder="Select a Time Zone"
      ></app-select>
      <app-tooltip [form]="'system.provider'" [uid]="'TimeZone'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Program Name Override</label>
      <input
        type="text"
        #organizationNameOverride
        class="form-control"
        name="OrganizationNameOverride"
        [(ngModel)]="model.OrganizationNameOverride"
      />
      <app-tooltip [form]="'system.provider'" [uid]="'OrganizationNameOverride'"></app-tooltip>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group">
      <label class="control-label">Program Phone Number Override</label>
      <input
        type="text"
        #organizationPhoneNumberOverride
        class="form-control"
        name="OrganizationPhoneNumberOverride"
        [(ngModel)]="model.OrganizationPhoneNumberOverride"
        [appInputMask]="util.constants.masks.usPhone"
      />
      <app-tooltip
        [form]="'system.provider'"
        [uid]="'OrganizationPhoneNumberOverride'"
      ></app-tooltip>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="check-form-group" style="padding-top: 30px">
      <div class="check">
        <input type="checkbox" id="IsAnchor" name="IsAnchor" [(ngModel)]="model.IsAnchor" />
        <label for="IsAnchor"></label>
      </div>
      <label for="IsAnchor">Is Anchor</label>
    </div>
  </div>

  <div class="col-md-3">
    <div class="check-form-group" style="padding-top: 30px" *ngIf="showConnectGeographicToggle()">
      <div class="check">
        <input
          type="checkbox"
          id="GeographicToggle"
          name="GeographicToggle"
          [(ngModel)]="geographicToggle"
        />
        <label for="GeographicToggle"></label>
      </div>
      <label for="GeographicToggle">Override Geography Check Address</label>
    </div>
  </div>
</div>

<div class="row address">
  <div class="col-md-6">
    <app-address
      [isRequired]="false"
      #physicalAddress
      [model]="model.PhysicalAddress"
      [title]="'Physical Address'"
      [usePayer]="false"
    ></app-address>
  </div>

  <div class="col-md-6">
    <app-address
      [isRequired]="false"
      #mailingAddress
      [model]="model.MailingAddress"
      [title]="'Mailing Address'"
      [usePayer]="false"
      [linkedComponent]="physicalAddress"
    ></app-address>
  </div>
</div>

<div class="row address" *ngIf="geographicToggle">
  <div class="col-md-12">
    <app-address
      [isRequired]="false"
      #locationCoverageAddress
      [model]="model.LocationCoverageAddress"
      [title]="'Connect Geography Check Address Override'"
      [usePayer]="false"
      [provider]="this.model"
    ></app-address>
  </div>
</div>

<div class="panel panel-default" *ngIf="model">
  <div class="panel-heading">
    <div class="row">
      <div class="col-xs-8">
        <h3 class="panel-title">Accounting Data</h3>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Vendor Id</label>
          <input
            type="text"
            class="form-control"
            name="AccountingVendorId"
            [(ngModel)]="model.AccountingVendorId"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Vendor Name</label>
          <input
            type="text"
            class="form-control"
            name="AccountingName"
            [(ngModel)]="model.AccountingName"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Term</label>
          <input type="text" class="form-control" name="Term" [(ngModel)]="model.Term" />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">PeopleSoft Vendor ID</label>
          <input
            type="text"
            #peopleSoftVendorId
            class="form-control"
            name="PeopleSoftVendorId"
            [(ngModel)]="model.PeopleSoftVendorId"
            [appInputMask]="util.constants.masks.leadingZeros(10)"
          />
          <app-tooltip [form]="'system.provider'" [uid]="'PeopleSoftVendorId'"></app-tooltip>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">PeopleSoft Location ID</label>
          <input
            type="text"
            #peopleSoftLocationId
            class="form-control"
            name="PeopleSoftLocationId"
            [(ngModel)]="model.PeopleSoftLocationId"
            [appInputMask]="util.constants.masks.leadingZeros(3)"
          />
          <app-tooltip [form]="'system.provider'" [uid]="'PeopleSoftLocationId'"></app-tooltip>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Market Id</label>
          <input
            type="text"
            class="form-control"
            name="AccountingMarketId"
            [(ngModel)]="model.AccountingMarketId"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Market Name</label>
          <input
            type="text"
            class="form-control"
            name="AccountingMarketName"
            [(ngModel)]="model.AccountingMarketName"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">PeopleSoft Operating Unit</label>
          <input
            type="text"
            #peopleSoftOperatingUnit
            class="form-control"
            name="PeopleSoftOperatingUnit"
            [(ngModel)]="model.PeopleSoftOperatingUnit"
            [maxlength]="8"
          />
          <app-tooltip [form]="'system.provider'" [uid]="'PeopleSoftOperatingUnit'"></app-tooltip>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">PeopleSoft Organization Unit Name</label>
          <input
            type="text"
            #peopleSoftOrgUnitName
            class="form-control"
            name="PeopleSoftOrgUnitName"
            [(ngModel)]="model.PeopleSoftOrgUnitName"
          />
          <app-tooltip [form]="'system.provider'" [uid]="'PeopleSoftOrgUnitName'"></app-tooltip>
        </div>
      </div>
    </div>
  </div>
</div>
